<template>
  <div>
    <div class='dashboard-editor-container'>
      <el-header align='center'>
        <el-button style='float:right;' type='success' icon='el-icon-refresh' @click='handleRefreshClick'>刷新
        </el-button>
      </el-header>
      <el-row :gutter='20'>
        <el-table
          ref='devTable'
          :data='tableData' v-loading='loading'
          :default-sort="{prop: 'date', order: 'descending'}"
          @current-change='rowClick'
          @row-click='rowClick'>
          <el-table-column prop='station_name' label='站点名称' show-overflow-tooltip>
            <template slot-scope='scope'>
              <div v-if='(scope.row.station_name.length <=0)' style='color:#F56C6C'>
                --未绑定站点--
              </div>
              <div v-else>{{ scope.row.station_name }}</div>
            </template>
          </el-table-column>
          <el-table-column prop='id' label='机柜编号' show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop='code' label='自定义编号' show-overflow-tooltip>
            <template slot-scope='scope'>
              <div v-if='(scope.row.code.length <=0)' style='color:#F56C6C'>
                -未自定义-
              </div>
              <div v-else> {{ scope.row.code }}</div>
            </template>
          </el-table-column>
          <el-table-column prop='bat_u' label='电池电压'>
            <template slot-scope='scope'>
              {{ (scope.row.bat_u / 100).toFixed(2) }} V
            </template>
          </el-table-column>
          <el-table-column prop='bi' label='水箱水位' show-overflow-tooltip>
            <template slot-scope='scope'>
              <div v-if='parseWaterLevel(scope.row.bi).length>0' style='color:#F56C6C'>
                {{ parseWaterLevel(scope.row.bi) }}
              </div>
              <div v-else style='color:#67C23A'>
                正常
              </div>
            </template>
          </el-table-column>

          <el-table-column prop='bo' label='水泵状态'>
            <template slot-scope='scope'>
              <div v-if='(scope.row.bo&0x0002)>0' style='color:#F56C6C'>
                开启
              </div>
              <div v-else style='color:#67C23A'>
                关闭
              </div>
            </template>
          </el-table-column>

          <el-table-column prop='bo' label='柜照明灯'>
            <template slot-scope='scope'>
              <div v-if='(scope.row.bo&0x0001)>0' style='color:#F56C6C'>
                开启
              </div>
              <div v-else style='color:#67C23A'>
                关闭
              </div>
            </template>
          </el-table-column>
          <el-table-column prop='bo' label='柜内风扇'>
            <template slot-scope='scope'>
              <div v-if='(scope.row.bo&0x0008)>0' style='color:#F56C6C'>
                开启
              </div>
              <div v-else style='color:#67C23A'>
                关闭
              </div>
            </template>
          </el-table-column>

          <el-table-column prop='bo' label='补水电磁阀'>
            <template slot-scope='scope'>
              <div v-if='(scope.row.bo&0x0010)>0' style='color:#F56C6C'>
                开启
              </div>
              <div v-else style='color:#67C23A'>
                关闭
              </div>
            </template>
          </el-table-column>

          <el-table-column prop='bo' label='充电仓喷淋'>
            <template slot-scope='scope'>
              <div v-if='(scope.row.bo&0x0020)>0' style='color:#F56C6C'>
                开启
              </div>
              <div v-else style='color:#67C23A'>
                关闭
              </div>
            </template>
          </el-table-column>

          <el-table-column prop='bo' label='充电插座喷淋'>
            <template slot-scope='scope'>
              <div v-if='(scope.row.bo&0x0040)>0' style='color:#F56C6C'>
                开启
              </div>
              <div v-else style='color:#67C23A'>
                关闭
              </div>
            </template>
          </el-table-column>

          <el-table-column prop='bi' label='机柜后门'>
            <template slot-scope='scope'>
              <div v-if='(scope.row.bi&0x8000)<=0' style='color:#F56C6C'>
                开启
              </div>
              <div v-else style='color:#67C23A'>
                关闭
              </div>
            </template>
          </el-table-column>

          <el-table-column prop='stat' label='消防灯' show-overflow-tooltip>
            <template slot-scope='scope'>
              <div v-if='(scope.row.stat&0x0001)>0' style='color:#E65D6E'>
                红色灯亮
              </div>
              <div v-else-if='(scope.row.stat&0x0002)>0' style='color:green'>
                绿色灯亮
              </div>
              <div v-else-if='(scope.row.stat&0x0004)>0' style='color:sandybrown'>
                黄色灯亮
              </div>
              <div v-else>
                关闭
              </div>
            </template>
          </el-table-column>
          <el-table-column prop='stat' label='急停按钮'>
            <template slot-scope='scope'>
              <div v-if='(scope.row.stat&0x0100)>0' style='color:#E65D6E'>
                已按
              </div>
              <div v-else style='color:#67C23A'>
                未按
              </div>
            </template>
          </el-table-column>
          <el-table-column prop='com' label='串口通信' show-overflow-tooltip>
            <template slot-scope='scope'>
              <div v-if='(scope.row.com&0x01)>0' style='color:#E65D6E' class='blink'>
                -柜控板故障-
              </div>
              <div v-else-if='(scope.row.com&0x02)>0' style='color:#E65D6E' class='blink'>
                -终端板故障-
              </div>
              <div v-else style='color:#67C23A'>
                正常
              </div>
            </template>
          </el-table-column>
          <el-table-column prop='updated_at' label='更新时间' width='160'></el-table-column>
          <el-table-column prop='updated_at' label='是否在线'>
            <template slot-scope='scope'>
              <div v-if='(diffDate(scope.row.updated_at)/1000)>120' style='color:#F56C6C' class='blink'>离线</div>
              <div v-else style='color:#67C23A'>在线</div>
            </template>
          </el-table-column>
          <el-table-column prop='enable' label='是否启用'>
            <template slot-scope='scope'>
              <div v-if='scope.row.enable==1' style='color:#E65D6E'>
                禁用
              </div>
              <div v-else style='color:#67C23A'>
                启用
              </div>
            </template>
          </el-table-column>
          <el-table-column label='操作' width='180'>
            <template slot-scope='scope'>
              <el-tooltip class='item' effect='dark' content='命令' placement='top'>
                <el-button type='text' @click='handleCmdClick(scope.row)'>
                  <svg-icon icon-class='ali_cmd'></svg-icon>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </div>


    <div style='padding: 0px 32px 32px 32px;background-color: rgb(240, 242, 245);position: relative;'>
      <el-row :gutter='20' style='background-color: white;padding: 20px;'>
        <el-tabs v-model='activeName' @tab-click='handleTabClick' tab-position='left'>
          <el-tab-pane label='充电插座' name='pole'>
            <div style='padding: 0px 20px 20px 0px;float: right'>
              <el-tag>充电插座总数: {{ sockets.length }} 个</el-tag>
            </div>
            <el-table :data='sockets' ref='socketTable' border
                      style='padding-left: 20px; '>
              <el-table-column prop='uuid' label='绑码情况' show-overflow-tooltip>
                <template slot-scope='scope'>
                  <div v-if='(scope.row.uuid.length <=0)' style='color:#F56C6C'>
                    -未绑定-
                  </div>
                  <div v-else>已绑定</div>
                </template>
              </el-table-column>
              <el-table-column prop='code' label='自定义编号' show-overflow-tooltip>
                <template slot-scope='scope'>
                  <div v-if='(scope.row.code.length <=0)' style='color:#F56C6C'>
                    -未自定义-
                  </div>
                  <div v-else> {{ scope.row.code }}</div>
                </template>
              </el-table-column>
              <!--              <el-table-column prop='channel' label='插座端口'>-->
              <!--                <template slot-scope='scope'>-->
              <!--                  {{ scope.row.channel }} 号-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column prop='u' label='充电电压'>
                <template slot-scope='scope'>
                  {{ (scope.row.u / 10).toFixed(2) }} V
                </template>
              </el-table-column>
              <el-table-column prop='i' label='充电电流'>
                <template slot-scope='scope'>
                  {{ (scope.row.i / 1000).toFixed(2) }} A
                </template>



              </el-table-column>

              <el-table-column prop='stg' label='充电状态'>
                <template slot-scope='scope'>

                  <div v-if='scope.row.stg==0' style='color:#909399'>空闲</div>
                  <div v-if='scope.row.stg==1' style='color:#409EFF'>等待连接充电器</div>
                  <div v-if='scope.row.stg==2' style='color:#409EFF'>等待充电器启动</div>
                  <div v-if='scope.row.stg==3' style='color:#409EFF'>快充</div>
                  <div v-if='scope.row.stg==4' style='color:#409EFF'>浮充</div>
                  <div v-if='scope.row.stg==5' style='color:#67C23A'>完成</div>

                  <div v-if='scope.row.stg==6' style='color:#F56C6C'>错误-电流超标</div>
                  <div v-if='scope.row.stg==7' style='color:#F56C6C'>错误-没有连接充电器</div>
                  <div v-if='scope.row.stg==8' style='color:#F56C6C'>错误-充电电流突增</div>
                  <div v-if='scope.row.stg==9' style='color:#F56C6C'>错误-电压异常</div>
                  <div v-if='scope.row.stg==10' style='color:#909399'>停止充电</div>
                  <div v-if='scope.row.stg==11' style='color:#E6A23C'>强制充电</div>
                  <div v-if='scope.row.stg==12' style='color:#F56C6C'>充电器异常断开</div>
                  <div v-if='scope.row.stg==13' style='color:#F56C6C'>消防报警</div>
                </template>
              </el-table-column>
              <el-table-column prop='stat' label='设备状态'>
                <template slot-scope='scope'>
                  <div v-if='parseSocketStatus(scope.row.stat).length<=0' style='color:#67C23A'>
                    正常
                  </div>
                  <div v-else style='color:#E65D6E'>
                    {{ parseSocketStatus(scope.row.stat) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop='err' label='故障状态'>
                <template slot-scope='scope'>
                  <div v-if='parseSocketError(scope.row.err).length<=0' style='color:#67C23A'>
                    正常
                  </div>
                  <div v-else style='color:#E65D6E'>
                    {{ parseSocketError(scope.row.err) }}
                  </div>

                </template>
              </el-table-column>
              <el-table-column prop='updated_at' label='更新时间' />

              <el-table-column prop='pole_id' label='备注'>
                <template slot-scope='scope'>
                  {{ (scope.row.pole_id >> 4) - 3 }}号主站端口-{{ scope.row.pole_id & 0xF }}号充电桩-{{ scope.row.channel }}号插座
                </template>
              </el-table-column>

              <el-table-column prop='enable' label='是否启用'>
                <template slot-scope='scope'>
                  <div v-if='scope.row.enable==1' style='color:#E65D6E'>
                    禁用
                  </div>
                  <div v-else style='color:#67C23A'>
                    启用
                  </div>
                </template>
              </el-table-column>

              <el-table-column label='操作'>
                <template slot-scope='scope'>
                  <el-tooltip class='item' effect='dark' content='命令' placement='top'>
                    <el-button type='text' @click='handleSocketCmdClick(scope.row)'>
                      <svg-icon icon-class='ali_cmd'></svg-icon>
                    </el-button>
                  </el-tooltip>

                  <el-tooltip class='item' effect='dark' content='编辑' placement='top'>
                    <el-button icon='el-icon-edit' type='text'
                               @click='handleSocketUpdateClick(scope.row)'></el-button>
                  </el-tooltip>

                  <el-tooltip v-if='scope.row.uuid.length>0' class='item' effect='dark' content='插座二维码' placement='top'>
                    <el-button type='text' @click='handleSocketQRCodeClick(scope.row)'>
                      <svg-icon icon-class='ali_qrcode'></svg-icon>
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label='充电仓位' name='box'>
            <!--            <div style='padding: 20px 20px 20px 0px;'>-->
            <!--              <el-tag>充电仓</el-tag>-->
            <!--            </div>-->
            <el-table :data='tableData[0].boxes' border ref='boxTable' style='padding-left: 20px;'
                      @current-change='boxRowClick'
                      @row-click='boxRowClick'>
              <el-table-column prop='t2' label='充电仓号'>
                <template slot-scope='scope'>
                  {{ (scope.row.box_id - 10) }}号
                </template>
              </el-table-column>
              <!--              <el-table-column prop='code' label='自定义编号' show-overflow-tooltip>-->
              <!--                <template slot-scope='scope'>-->
              <!--                  <div v-if='(scope.row.code.length <=0)' style='color:#F56C6C'>-->
              <!--                    &#45;&#45;未自定义&#45;&#45;-->
              <!--                  </div>-->
              <!--                  <div v-else> {{ scope.row.code }}</div>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column prop='t1' label='温度1'>
                <template slot-scope='scope'>
                  {{ (scope.row.t1 / 100).toFixed(2) }} 度
                </template>
              </el-table-column>
              <el-table-column prop='t2' label='温度2(默认)'>
                <template slot-scope='scope'>
                  {{ (scope.row.t2 / 100).toFixed(2) }} 度
                </template>
              </el-table-column>
              <el-table-column prop='led' label='三色指示灯' show-overflow-tooltip>
                <template slot-scope='scope'>
                  {{ parseLedStatus(scope.row.led) }}
                </template>
              </el-table-column>
              <el-table-column prop='stat' label='设备状态'>
                <template slot-scope='scope'>
                  <div v-if='parseBoxStatus(scope.row.stat).length<=0' style='color:#67C23A'>
                    正常
                  </div>
                  <div v-else style='color:#E65D6E'>
                    {{ parseBoxStatus(scope.row.stat) }}
                  </div>
                </template>
              </el-table-column>
              <!--              <el-table-column prop='err' label='故障状态' show-overflow-tooltip>-->
              <!--                <template slot-scope='scope'>-->
              <!--                  <div v-if='parsePoleError(scope.row.err).length<=0' style='color:#67C23A'>-->
              <!--                    正常-->
              <!--                  </div>-->
              <!--                  <div v-else style='color:#E65D6E'>-->
              <!--                    {{ parsePoleError(scope.row.err) }}-->
              <!--                  </div>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column prop='com' label='串口通信'>
                <template slot-scope='scope'>
                  <div v-if='(scope.row.com)>0' style='color:#E65D6E' class='blink'>
                    故障
                  </div>
                  <div v-else style='color:#67C23A'>
                    正常
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop='updated_at' label='更新时间' />
              <el-table-column prop='enable' label='是否启用'>
                <template slot-scope='scope'>
                  <div v-if='scope.row.enable==1' style='color:#E65D6E'>
                    禁用
                  </div>
                  <div v-else style='color:#67C23A'>
                    启用
                  </div>
                </template>
              </el-table-column>
              <el-table-column label='操作'>
                <template slot-scope='scope'>

                  <el-tooltip class='item' effect='dark' content='命令' placement='top'>
                    <el-button type='text' @click='handleBoxCmdClick(scope.row)'>
                      <svg-icon icon-class='ali_cmd'></svg-icon>
                    </el-button>
                  </el-tooltip>

                  <el-tooltip class='item' effect='dark' content='编辑' placement='top'>
                    <el-button icon='el-icon-edit' type='text'
                               @click='handleBoxUpdateClick(scope.row)'></el-button>
                  </el-tooltip>


                  <!--                  <el-tooltip class='item' effect='dark' content='编辑' placement='top'>-->
                  <!--                    <el-button icon='el-icon-edit' type='text'-->
                  <!--                               @click='handleBoxUpdateClick(scope.row)'></el-button>-->
                  <!--                  </el-tooltip>-->
                </template>
              </el-table-column>
            </el-table>
            <div style='padding-top: 20px;'>
              <div style='padding: 20px 20px 20px 0px;alignment: center'>
                <el-tag v-if='selected_box_id>0'>{{ selected_box_id - 10 }}号充电仓-充电状态</el-tag>
              </div>
            </div>
            <el-table :data='box_sockets' ref='box_socket_Table' border style='padding-left: 20px; '>
              <el-table-column prop='u' label='充电电压'>
                <template slot-scope='scope'>
                  {{ (scope.row.u / 10).toFixed(2) }} V
                </template>
              </el-table-column>
              <el-table-column prop='i' label='充电电流'>
                <template slot-scope='scope'>
                  {{ (scope.row.i / 1000).toFixed(2) }} A
                </template>
              </el-table-column>
              <el-table-column prop='stg' label='充电状态'>
                <template slot-scope='scope'>
                  <div v-if='scope.row.stg==0' style='color:#909399'>空闲</div>
                  <div v-if='scope.row.stg==1' style='color:#409EFF'>等待连接充电器</div>
                  <div v-if='scope.row.stg==2' style='color:#409EFF'>等待充电器启动</div>
                  <div v-if='scope.row.stg==3' style='color:#409EFF'>快充</div>
                  <div v-if='scope.row.stg==4' style='color:#409EFF'>浮充</div>
                  <div v-if='scope.row.stg==5' style='color:#67C23A'>完成</div>
                  <div v-if='scope.row.stg==6' style='color:#F56C6C'>错误-电流超标</div>
                  <div v-if='scope.row.stg==7' style='color:#F56C6C'>错误-没有连接充电器</div>
                  <div v-if='scope.row.stg==8' style='color:#F56C6C'>错误-充电电流突增</div>
                  <div v-if='scope.row.stg==9' style='color:#F56C6C'>错误-电压异常</div>
                  <div v-if='scope.row.stg==10' style='color:#909399'>停止充电</div>
                  <div v-if='scope.row.stg==11' style='color:#E6A23C'>强制充电</div>
                  <div v-if='scope.row.stg==12' style='color:#F56C6C'>充电器异常断开</div>
                  <div v-if='scope.row.stg==13' style='color:#F56C6C'>消防报警</div>
                </template>
              </el-table-column>

              <el-table-column prop='stat' label='设备状态'>
                <template slot-scope='scope'>
                  <div v-if='parseSocketStatus(scope.row.stat).length<=0' style='color:#67C23A'>
                    正常
                  </div>
                  <div v-else style='color:#E65D6E'>
                    {{ parseSocketStatus(scope.row.stat) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop='err' label='故障状态'>
                <template slot-scope='scope'>
                  <div v-if='parseSocketError(scope.row.err).length<=0' style='color:#67C23A'>
                    正常
                  </div>
                  <div v-else style='color:#E65D6E'>
                    {{ parseSocketError(scope.row.err) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop='updated_at' label='更新时间' />
              <el-table-column prop='pole_id' label='备注'>
                <template slot-scope='scope'>
                  {{ (scope.row.pole_id >> 4) }}号主站端口-{{ scope.row.pole_id & 0xF }}号充电桩-{{ scope.row.channel }}号插座
                </template>
              </el-table-column>
              <el-table-column label='操作'>
                <template slot-scope='scope'>
                  <el-tooltip class='item' effect='dark' content='命令' placement='top'>
                    <el-button type='text' @click='handleBoxSocketCmdClick(scope.row)'>
                      <svg-icon icon-class='ali_cmd'></svg-icon>
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label='充电桩' name='board'>
            <div style='padding: 0px 20px 20px 0px;float: right'>
              <el-tag>充电桩</el-tag>
            </div>
            <el-table :data='tableData[0].poles' ref='poleTable' border style='padding-left: 20px;'
                      @current-change='poleRowClick'
                      @row-click='poleRowClick'>
              <!--              <el-table-column prop='id' disabled label='序号' />-->
              <el-table-column prop='HW' label='(终端板)分配'>
                <template slot-scope='scope'>
                  <div v-if='(scope.row.pole_id>>4)==1||(scope.row.pole_id>>4)==2||(scope.row.pole_id>>4)==3'
                       style='color: #E6A23C'>
                    充电仓专用
                  </div>
                  <dev v-else>
                    充电桩专用
                  </dev>
                </template>
              </el-table-column>
              <el-table-column prop='pole_id' label='备注'>
                <template slot-scope='scope'>
            <span v-if='(scope.row.pole_id>>4)<=3'>
                      {{ (scope.row.pole_id >> 4) }}号主站端口-{{ scope.row.pole_id & 0xF }}号充电桩
            </span>
                  <span v-else>
                   {{ (scope.row.pole_id >> 4) - 3 }}号主站端口-{{ scope.row.pole_id & 0xF }}号充电桩
            </span>
                  <!--                  <span v-else-if='(scope.row.pole_id>>4)==3'>-->
                  <!--              主站3号-充电桩{{ scope.row.pole_id & 0xF }}号-->
                  <!--            </span>-->
                  <!--                  <span v-else-if='(scope.row.pole_id>>4)==4'>-->
                  <!--              主站4号-充电桩{{ scope.row.pole_id & 0xF }}号-->
                  <!--            </span>-->
                  <!--                  <span v-else-if='(scope.row.pole_id>>4)==5'>-->
                  <!--              主站5号-充电桩{{ scope.row.pole_id & 0xF }}号-->
                  <!--            </span>-->
                  <!--                  <span v-else-if='(scope.row.pole_id>>4)==6'>-->
                  <!--              主站6号-充电桩{{ scope.row.pole_id & 0xF }}号-->
                  <!--            </span>-->
                  <!--                  <span v-else-if='(scope.row.pole_id>>4)==7'>-->
                  <!--              主站7号-充电桩{{ scope.row.pole_id & 0xF }}号-->
                  <!--            </span>-->
                </template>
              </el-table-column>
              <!--              <el-table-column prop='mast_port' label='主箱端口' />-->
              <!--              <el-table-column prop='pole_id' label='从箱端口' />-->
              <el-table-column prop='stat' label='设备状态'>
                <template slot-scope='scope'>
                  <div v-if='(scope.row.stat&0x0001)>0' style='color:#67C23A'>
                    -运行指示灯亮-
                  </div>
                  <div v-if='(scope.row.stat&0x0002)>0' style='color:#E65D6E' class='blink'>
                    -烟雾报警灯亮-
                  </div>
                  <div v-if='(scope.row.stat&0x0004)>0' style='color:#E65D6E' class='blink'>
                    -消防喷淋启动-
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop='err' label='故障状态'>
                <template slot-scope='scope'>
                  <div v-if='parsePoleError(scope.row.err).length<=0' style='color:#67C23A'>
                    正常
                  </div>
                  <div v-else style='color:#E65D6E'>
                    {{ parsePoleError(scope.row.err) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop='com' label='串口通信'>
                <template slot-scope='scope'>
                  <div v-if='(scope.row.com)>0' style='color:#E65D6E' class='blink'>
                    故障
                  </div>
                  <div v-else style='color:#67C23A'>
                    正常
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop='updated_at' label='更新时间' />
              <el-table-column label='操作'>
                <template slot-scope='scope'>
                  <el-tooltip class='item' effect='dark' content='命令' placement='top'>
                    <el-button type='text' @click='handlePoleCmdClick(scope.row)'>
                      <svg-icon icon-class='ali_cmd'></svg-icon>
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>

            <div style='padding: 20px 20px 20px 0px;float: right'>
              <el-tag> 充电插座</el-tag>
            </div>
            <el-table :data='pole_sockets.length >0 ? pole_sockets:tableData[0].sockets ' ref='socketTable' border
                      style='padding-left: 20px; '>


              <el-table-column prop='code' label='自定义编号' show-overflow-tooltip>
                <template slot-scope='scope'>
                  <div v-if='(scope.row.code.length <=0)' style='color:#F56C6C'>
                    -未自定义-
                  </div>
                  <div v-else> {{ scope.row.code }}</div>
                </template>
              </el-table-column>
              <el-table-column prop='channel' label='插座端口'>
                <template slot-scope='scope'>
                  {{ scope.row.channel }} 号
                </template>
              </el-table-column>
              <el-table-column prop='u' label='充电电压'>
                <template slot-scope='scope'>
                  {{ (scope.row.u / 10).toFixed(2) }} V
                </template>
              </el-table-column>

              <el-table-column prop='i' label='充电电流'>
                <template slot-scope='scope'>
                  {{ (scope.row.i / 1000).toFixed(2) }} A
                </template>
              </el-table-column>

              <el-table-column prop='stg' label='充电状态'>
                <template slot-scope='scope'>

                  <div v-if='scope.row.stg==0' style='color:#909399'>空闲</div>
                  <div v-if='scope.row.stg==1' style='color:#409EFF'>等待连接充电器</div>
                  <div v-if='scope.row.stg==2' style='color:#409EFF'>等待充电器启动</div>
                  <div v-if='scope.row.stg==3' style='color:#409EFF'>快充</div>
                  <div v-if='scope.row.stg==4' style='color:#409EFF'>浮充</div>
                  <div v-if='scope.row.stg==5' style='color:#67C23A'>完成</div>

                  <div v-if='scope.row.stg==6' style='color:#F56C6C'>错误-电流超标</div>
                  <div v-if='scope.row.stg==7' style='color:#F56C6C'>错误-没有连接充电器</div>
                  <div v-if='scope.row.stg==8' style='color:#F56C6C'>错误-充电电流突增</div>
                  <div v-if='scope.row.stg==9' style='color:#F56C6C'>错误-电压异常</div>
                  <div v-if='scope.row.stg==10' style='color:#909399'>停止充电</div>
                  <div v-if='scope.row.stg==11' style='color:#E6A23C'>强制充电</div>
                  <div v-if='scope.row.stg==12' style='color:#F56C6C'>充电器异常断开</div>
                  <div v-if='scope.row.stg==13' style='color:#F56C6C'>消防报警</div>
                </template>
              </el-table-column>

              <el-table-column prop='stat' label='设备状态'>
                <template slot-scope='scope'>
                  <div v-if='parseSocketStatus(scope.row.stat).length<=0' style='color:#67C23A'>
                    正常
                  </div>
                  <div v-else style='color:#E65D6E'>
                    {{ parseSocketStatus(scope.row.stat) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop='err' label='故障状态'>
                <template slot-scope='scope'>
                  <div v-if='parseSocketError(scope.row.err).length<=0' style='color:#67C23A'>
                    正常
                  </div>
                  <div v-else style='color:#E65D6E'>
                    {{ parseSocketError(scope.row.err) }}
                  </div>

                </template>
              </el-table-column>
              <el-table-column prop='updated_at' label='更新时间' />
              <el-table-column label='操作'>
                <template slot-scope='scope'>
                  <el-tooltip class='item' effect='dark' content='命令' placement='top'>
                    <el-button type='text' @click='handlePoleCmdClick(scope.row)'>
                      <svg-icon icon-class='ali_cmd'></svg-icon>
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-row>
    </div>

    <!-- 详情弹出框 -->
    <el-dialog title='命令' :visible.sync='cmdVisible'
               @close='handleCmdCancel'
               top='8vh' width='58%'>
      <el-form ref='cmdForm' :model='cmdForm' label-width='100px'>

        <el-row :gutter='24'>
          <el-col :span='24'>
            <el-form-item label='命令选项：' prop='ctrl' :rules="[{ required: 'true', message: `请选择命令项`,trigger: 'change'}]">
              <el-radio-group v-model='cmdForm.ctrl' @change='handleCmdRadio' type='vertical'>
                <div v-if='cmdForm.type==0x01'>

                  <el-row :gutter='24'>
                    <el-col :span='12'>

                      <el-radio label='cabinet_bo_lamp_open'>
                        打开柜外照明灯
                      </el-radio>

                    </el-col>
                    <el-col :span='12'>
                      <el-radio label='cabinet_bo_lamp_close'>
                        关闭柜外照明灯
                      </el-radio>

                    </el-col>

                  </el-row>


                  <el-row :gutter='24' style='margin-top: 15px'>
                    <el-col :span='12'>
                      <el-radio label='cabinet_bo_pump_open'>
                        打开水泵
                      </el-radio>
                    </el-col>
                    <el-col :span='12'>
                      <el-radio label='cabinet_bo_pump_close'>
                        关闭水泵
                      </el-radio>
                    </el-col>
                  </el-row>


                  <el-row :gutter='24' style='margin-top: 15px'>
                    <el-col :span='12'>
                      <el-radio label='cabinet_bo_fan_open'>
                        打开柜内风扇
                      </el-radio>
                    </el-col>
                    <el-col :span='12'>

                      <el-radio label='cabinet_bo_fan_close'>
                        关闭柜内风扇
                      </el-radio>
                    </el-col>
                  </el-row>


                  <el-row :gutter='24' style='margin-top: 15px'>
                    <el-col :span='12'>

                      <el-radio label='cabinet_bo_feed_water_open'>
                        打开补水电磁阀
                      </el-radio>
                    </el-col>
                    <el-col :span='12'>

                      <el-radio label='cabinet_bo_feed_water_close'>
                        关闭补水电磁阀
                      </el-radio>
                    </el-col>
                  </el-row>
                  <el-row :gutter='24' style='margin-top: 15px'>
                    <el-col :span='12'>
                      <el-radio label='cabinet_bo_box_spray_open'>
                        打开充电仓喷淋
                      </el-radio>
                    </el-col>
                    <el-col :span='12'>
                      <el-radio label='cabinet_bo_box_spray_close'>
                        关闭充电仓喷淋
                      </el-radio>
                    </el-col>
                  </el-row>
                  <el-row :gutter='24' style='margin-top: 15px'>
                    <el-col :span='12'>
                      <el-radio label='cabinet_bo_pole_spray_open'>
                        打开充电插座喷淋
                      </el-radio>
                    </el-col>
                    <el-col :span='12'>
                      <el-radio label='cabinet_bo_pole_spray_close'>
                        关闭充电插座喷淋
                      </el-radio>
                    </el-col>
                  </el-row>
                </div>
                <div v-if='cmdForm.type==0x02'>
                  <el-radio label='box_door_open'>
                    打开柜门
                  </el-radio>
                  <el-radio label='box_light_open'>
                    打开照明灯
                  </el-radio>
                  <el-radio label='box_light_close'>
                    关闭照明灯
                  </el-radio>
                  <el-radio label='box_fan_open'>
                    打开风扇
                  </el-radio>
                  <el-radio label='box_fan_close'>
                    关闭风扇
                  </el-radio>
                </div>
                <div v-if='cmdForm.type==0x04'>
                  <el-row :gutter='24' v-if='chargeForm.cn!=0'>
                    <el-col :span='12'>
                      <el-radio label='socket_start_charge'>
                        开始充电
                      </el-radio>
                    </el-col>
                    <el-col :span='12'>
                      <el-radio label='socket_stop_charge'>
                        停止充电
                      </el-radio>
                    </el-col>
                  </el-row>


                  <el-row :gutter='24' style='margin:15px 0px 15px 0px' v-if='chargeForm.cn==0'>
                    <el-card class="box-card">
                    <el-col :span='12' style='margin: 0px 0px 15px 0px;'>
                      <el-radio label='pole_reset'>
                        复位
                      </el-radio>
                    </el-col>
                    </el-card>
                  </el-row>
                  <el-row :gutter='24' style='margin:15px 0px 15px 0px' v-if='chargeForm.cn==0'>



                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <span> <el-link :underline="false">交流板烟感报警【前】操作：</el-link></span>
                      </div>
                      <div style='margin-bottom: 15px'>
                        <el-col :span='12'>
                        <el-radio label='pole_start_spray'>
                          允许喷淋
                        </el-radio>
                      </el-col>
                        <el-col :span='12'>
                          <el-radio label='pole_stop_spray'>
                            禁止喷淋
                          </el-radio>
                        </el-col>
                      </div>
                      <div style='margin: 40px 0px 0px 15px;'>
                        <el-link type="danger" disabled>备注：<br>交流板重新上电默认'允许喷淋'；<br>若'允许喷淋'，有烟感时【会】启动喷淋；<br>若'禁止喷淋'，有烟感时【不会】启动喷淋；</el-link>
                      </div>
                    </el-card>
                  </el-row>
                  <el-row :gutter='24' style='margin:15px 0px 15px 0px' v-if='chargeForm.cn==0'>
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <span> <el-link :underline="false">交流板烟感报警【后】操作：</el-link></span>
                      </div>
                      <div style='margin-bottom: 15px'>
                      <el-col :span='12'>
                        <el-radio label='pole_background_start_spray'>
                          启动喷淋
                        </el-radio>
                      </el-col>
                      <el-col :span='12'>
                        <el-radio label='pole_background_stop_spray'>
                          停止喷淋
                        </el-radio>
                      </el-col>
                      </div>
                      <div style='margin: 40px 0px 0px 15px;'>
                        <el-link type="danger" disabled>备注：<br>烟感报警后的20秒内，后台可'启动喷淋'，超过20秒，交流板自动开启喷淋；<br>烟感报警后且交流板开启喷淋时，后台可'停止喷淋'；</el-link>
                      </div>
                    </el-card>
                  </el-row>

                </div>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter='24'>
          <el-col :span='14'>

            <div v-if="cmdForm.ctrl =='socket_start_charge'">

              <el-form-item label='最大电流' :label-width='formLabelWidth' prop='max_current'>
                <el-input v-model.number='chargeForm.max_current' :disabled='isDisabled'>
                  <template slot='append'>mA</template>
                </el-input>
              </el-form-item>
              <el-form-item label='浮充电流' :label-width='formLabelWidth' prop='float_current'>
                <el-input v-model.number='chargeForm.float_current' :disabled='isDisabled'>
                  <template slot='append'>mA</template>
                </el-input>
              </el-form-item>

              <el-form-item label='电流突增' :label-width='formLabelWidth' prop='rise_current'>
                <el-input v-model.number='chargeForm.rise_current' :disabled='isDisabled'>
                  <template slot='append'>mA</template>
                </el-input>
              </el-form-item>

              <el-form-item label='浮充时长' :label-width='formLabelWidth' prop='float_time'>
                <el-input v-model.number='chargeForm.float_time' :disabled='isDisabled'>
                  <template slot='append'>秒</template>
                </el-input>
              </el-form-item>

              <el-form-item label='快充时长' :label-width='formLabelWidth' prop='float_time'>
                <el-input v-model.number='chargeForm.fast_time'>
                  <template slot='append'>秒</template>
                </el-input>
              </el-form-item>
            </div>

          </el-col>
          <el-col :span='6'>
          </el-col>
        </el-row>

        <el-row :gutter='24' style='margin-top: 20px'>
          <el-col :span='6'>
            <el-button icon='el-icon-caret-right' type='danger' plain @click='sendCmd'>
              发送
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-divider content-position='left'></el-divider>

      <span slot='footer' class='dialog-footer'>
                <el-button @click='handleCmdCancel'>关闭</el-button>
        </span>
    </el-dialog>

    <!-- 编辑信息 -->
    <el-dialog title='编辑' :visible.sync='socketEditVisible' width='50%' @closed='closeSocketUpdateDialog'>
      <el-form ref='socket_form' :model='socketForm'>
        <el-form-item label='插座编号' :label-width='formLabelWidth' prop='channel_id'>
          <el-input v-model='socketForm.id' disabled></el-input>
        </el-form-item>
        <el-form-item label='是否启用' :label-width='formLabelWidth' prop='enable'>
          <el-select v-model='socketForm.enable' placeholder='请选择'>
            <el-option
              v-for='item in enableOptions'
              :key='item.value'
              :label='item.label'
              :value='item.value'
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='自定义编号' :label-width='formLabelWidth' prop='code'>
          <el-input v-model='socketForm.code'></el-input>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='closeSocketUpdateDialog'>取 消</el-button>
        <el-button type='primary' @click='saveSocketUpdate'>确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑信息 -->
    <el-dialog title='编辑' :visible.sync='boxEditVisible' width='50%' @closed='closeBoxUpdateDialog'>
      <el-form ref='box_form' :model='boxForm'>
        <el-form-item label='充电仓号' :label-width='formLabelWidth' prop='id'>
          <el-input v-model='boxForm.id' disabled></el-input>
        </el-form-item>
        <el-form-item label='是否启用' :label-width='formLabelWidth' prop='enable'>
          <el-select v-model='boxForm.enable' placeholder='请选择'>
            <el-option
              v-for='item in enableOptions'
              :key='item.value'
              :label='item.label'
              :value='item.value'
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='closeBoxUpdateDialog'>取 消</el-button>
        <el-button type='primary' @click='saveBoxUpdate'>确 定</el-button>
      </div>
    </el-dialog>

    <!-- 设备详情 -->
    <el-dialog :title="'二维码内容:'+ QRCodeIDs[0]+''" :visible.sync='qrcodeVisible' width='40%' @closed='closeQRCodeDialog'>

      <div style='margin-top: 20px;' class='min'>
        <!--存放二维码-->
        <div class='qrcode one' id='qrcode' ref='qrCodeUrl' style='margin-top:20px; '></div>
      </div>

      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='closeQRCodeDialog'>关 闭</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='downLoadQrCode'>下 载</el-button>
      </div>
    </el-dialog>


  </div>

</template>

<script>
import { gateway } from '@/api/admin.js'
import ElContainer from '../../../node_modules/element-ui/packages/container/src/main.vue'
import QRCode from 'qrcodejs2'
import { URL } from '../../utils/golbal'

export default {
  name: 'monitoring',
  components: { ElContainer },

  data() {
    return {
      //*******设备信息
      cabinet_id: null,
      current_limit_id: null,
      tableData: [],
      form: {},

      activeName: 'pole',


      //******充电插座******
      sockets: [],
      pole_sockets: [],
      socketEditVisible: false,
      socketForm: {},
      enableOptions: [
        {
          value: 0,
          label: '启用'
        },
        {
          value: 1,
          label: '禁用'
        }
      ],
      //******充电仓******
      box_sockets: [],
      selected_box_id: null,


      //******充电仓位******
      boxEditVisible: false,
      boxForm: {},


      //***********设备二维码
      qrcodeVisible: false,
      QRCodeIDs: [],
      QRCodeURL: [],            //存放生成的二维码图片地址

      //设备详情
      detailVisible: false,
      cmdVisible: false,
      isDisabled: true,
      cmdForm: {
        type: 0x01,
        ctrl: null,
        cabinet_id: null,
        id: null,
        cn: null
      },
      chargeForm: {
        id: 0,
        cn: 0,
        max_current: 0,
        float_current: 0,
        rise_current: 0,
        float_time: 0,
        fast_time: 300
      },
      cabinets: [],
      grids: [],
      controls: [],
      clients: [],
      channels: [],
      ac_channels: [],
      show: {
        loading: false
      },
      pagination: {
        page_size: 28, //页面数据条数
        page_no: 1, //页号
        count: 30
      },
      formLabelWidth: '120px'
    }
  },
  created() {
    this.cabinet_id = parseInt(this.$route.query.cabinet_id)
    this.getTableData()
  },
  watch: {
    tableData: function() {
      this.$nextTick(function() {
        this.$refs.devTable.setCurrentRow(this.tableData[0])
      })
    }
  },

  methods: {

    handleRefreshClick() {
      this.getTableData()
    },

    getTableData() {
      this.loading = true
      let str = JSON.stringify({
        cabinet_id: parseInt(this.cabinet_id),
        station_name: ''
      })
      gateway({
        func: 'get_cabinet_list',
        page_no: this.pagination.page_no,
        page_size: this.pagination.page_size,
        params: str
      }).then(res => {
        this.loading = false
        this.tableData = res.result
        this.pagination.count = res.count

        //充电插座数据处理
        this.sockets = []
        for (var i = 0; i < this.tableData[0].sockets.length; i++) {
          if ((this.tableData[0].sockets[i].pole_id >> 4) > 3) { //去掉充电仓的充电插座
            this.sockets.push(this.tableData[0].sockets[i])
          }
        }

        this.sockets.sort((a, b) => {
          return a.pole_id - b.pole_id
        })
      })
    },

    // 点击跳转页数
    handleCurrentChange(val) {
      this.pagination.page_no = val
      this.getTableData()
    },

    handleSizeChange(val) {
      this.pagination.page_size = val
      this.getTableData()
    },
    handleTabClick(val) {

    },

    //关闭编辑对话框
    closeDialog() {
      this.editVisible = false
      this.form = {}
      this.$refs['form'].resetFields()
      this.$refs['form'].clearValidate()
    },

    handleSettingClick(row) {
      this.editVisible = true
      this.form = Object.assign({
        id: row.id,
        station_id: row.station_id,
        station_name: row.station_name,
        code: row.code
      })
    },


    //*************************************************************************************
    //***************************************************充电仓位***************************
    //*************************************************************************************
    closeBoxUpdateDialog() {
      this.boxEditVisible = false
      this.boxForm = {}
      this.$refs['box_form'].resetFields()
      this.$refs['box_form'].clearValidate()
    },
    handleBoxUpdateClick(row) {
      this.boxEditVisible = true
      this.boxForm = Object.assign({
        id: row.id,
        enable: row.enable
      })
    },

    saveBoxUpdate() {
      this.$refs.box_form.validate(valid => {
        if (valid) {
          let str = JSON.stringify({
            id: this.boxForm.id,
            enable: this.boxForm.enable
          })
          gateway({
            func: 'other_update_box',
            params: str
          }).then(() => {
            this.closeBoxUpdateDialog()
            this.getTableData()
            //TODO
          })
        } else {
          return false
        }
      })
    },
    //*************************************************************************************
    //***************************************************充电插座*************************
    //*************************************************************************************


    closeSocketUpdateDialog() {
      this.socketEditVisible = false
      this.socketForm = {}
      this.$refs['socket_form'].resetFields()
      this.$refs['socket_form'].clearValidate()
    },

    handleSocketUpdateClick(row) {
      this.socketEditVisible = true
      this.socketForm = Object.assign({
        id: row.id,
        code: row.code,
        enable: row.enable
      })
    },
    saveSocketUpdate() {
      this.$refs.socket_form.validate(valid => {
        if (valid) {
          let str = JSON.stringify({
            id: this.socketForm.id,
            code: this.socketForm.code,
            enable: this.socketForm.enable
          })
          gateway({
            func: 'set_socket',
            params: str
          }).then(() => {
            this.closeSocketUpdateDialog()
            this.getTableData()
            //TODO
          })
        } else {
          return false
        }
      })
    },

    //*************************************************************************************
    //***************************************************设备二维码*************************
    //*************************************************************************************
    //关闭对话框
    closeQRCodeDialog() {
      this.qrcodeVisible = false
    },

    handleQRCodeClick(row) {
      this.qrcodeVisible = true
      setTimeout(() => {
        this.QRCodeIDs = []
        this.QRCodeIDs.push(this.$global.URL.Box + row.id)
        this.createQrCode()
      }, 1000)
    },
    // 生成二维码
    createQrCode() {
      document.querySelector('.qrcode').innerHTML = ''  // 清空div中的二维码图片
      this.QRCodeIDs.forEach((each) => {                       // 循环创建二维码
        new QRCode(this.$refs.qrCodeUrl, {             // 将创建好的二维码图片放在div中
          text: each,                                  // 需要转换为二维码的内容
          width: 500,
          height: 500,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    downLoadQrCode() {
      var img = document.querySelectorAll('.qrcode img')
      for (var i = 0; i < img.length; i++) {
        var url = img[i].src
        var a = document.createElement('a')
        var event = new MouseEvent('click') // 创建一个单击事件
        a.href = url
        a.download = this.QRCodeIDs[i] + '.png'// 图片名称
        a.dispatchEvent(event) // 触发a的单击事件
      }
    },
    //*************************************************************************************
    //***************************************************设备详情*************************
    //*************************************************************************************
    //关闭对话框
    closeDetailDialog() {
      this.detailVisible = false
    },

    handleDetailClick(row) {
      this.detailVisible = true
    },

    rowClick(row, column, event) {
      this.current_limit_id = row.current_limit_id
    },
    parseACSwitcherStatus(val) {
      let s = ''

      if ((val & 0x0001) > 0) { //0
        s += ' 继电器开始'
      }

      if ((val & 0x0002) > 0) {//1

      }

      if ((val & 0x0004) > 0) {//2

      }

      if ((val & 0x0008) > 0) {//3

      }

      if ((val & 0x0010) > 0) {//4

      }

      if ((val & 0x0020) > 0) {//5

      }
      if ((val & 0x0040) > 0) {//6

      }
      if ((val & 0x0080 > 0)) {//7
        s += ' 继电器结束'
      }
      if ((val & 0x0100) > 0) {//8
        s += ' 红灯开启'
      }
      if ((val & 0x0200) > 0) {//9
        s += ' 绿灯开启'
      }
      if ((val & 0x0400) > 0) {//10
        s += ' 黄灯开启'
      }

      return s
    }
    ,

    parseACSwitcherError(val) {
      let s = ''
      return s
    }
    ,

    //模糊搜索
    find() {
      this.getTableData()
    },
    diffDate(start) {
      return new Date().getTime() - new Date(start).getTime()
    }
    ,
    parseLedStatus(val) {
      let s = ''
      if ((val & 0x0001) > 0) { //0
        s += '红灯'
      }

      if ((val & 0x0002) > 0) {//1
        s += '绿灯'
      }

      if ((val & 0x0004) > 0) {//2
        s += '黄灯'
      }

      if ((val & 0x0100) > 0) {//8
        s += '常亮'
      }
      if ((val & 0x0200) > 0) {//9
        s += '常闭'
      }
      if ((val & 0x0400) > 0) {//10
        s += '闪烁'
      }

      if (s.length <= 0) {
        s = '常闭'
      }
      return s
    },
    handleCmdClick(row) {
      this.cmdVisible = true
      this.cmdForm.type = 0x01
      this.cmdForm.cabinet_id = row.id
    },
    handlePoleCmdClick(row) {
      this.cmdVisible = true
      this.cmdForm.type = 0x04
      this.cmdForm.cabinet_id = row.cabinet_id
      this.chargeForm.id = row.pole_id
      this.chargeForm.cn = 0
    },
    handleSocketCmdClick(row) {
      this.cmdVisible = true
      this.cmdForm.type = 0x04
      this.cmdForm.cabinet_id = row.cabinet_id
      this.chargeForm.id = row.pole_id
      this.chargeForm.cn = row.channel
    },

    handleBoxCmdClick(row) {
      this.cmdVisible = true
      this.cmdForm.type = 0x02
      this.cmdForm.cabinet_id = row.cabinet_id
      this.cmdForm.id = row.box_id
    },

    handleBoxSocketCmdClick(row) {
      this.cmdVisible = true
      this.cmdForm.type = 0x04
      this.cmdForm.cabinet_id = row.cabinet_id
      this.chargeForm.id = row.pole_id
      this.chargeForm.cn = row.channel
    },


    handleCmdRadio(val) {


      if (this.cmdForm.type == 0x01) { //柜控主板

        this.isDisabled = true

        let param = 0
        let param2 = 0

        switch (val) {

          case 'cabinet_bo_lamp_open':
            param = 1
            param2 = 1
            break
          case 'cabinet_bo_lamp_close':
            param = 1
            param2 = 2
            break

          case 'cabinet_bo_pump_open':
            param = 0x02
            param2 = 1
            break
          case 'cabinet_bo_pump_close':
            param = 0x02
            param2 = 2
            break

          case 'cabinet_bo_fan_open':
            param = 8
            param2 = 1
            break

          case 'cabinet_bo_fan_close':
            param = 8
            param2 = 2
            break

          case 'cabinet_bo_feed_water_open':
            param = 0x10
            param2 = 1
            break
          case 'cabinet_bo_feed_water_close':
            param = 0x10
            param2 = 2
            break

          case 'cabinet_bo_box_spray_open':
            param = 0x20
            param2 = 1
            break
          case 'cabinet_bo_box_spray_close':
            param = 0x20
            param2 = 2
            break

          case 'cabinet_bo_pole_spray_open':
            param = 0x40
            param2 = 1
            break
          case 'cabinet_bo_pole_spray_close':
            param = 0x40
            param2 = 2
            break


          default:
        }


        this.cmdForm = {
          req_id: 'test',
          cabinet_id: this.cmdForm.cabinet_id,
          ctrl: val,
          type: 0x01,
          data: {
            cmd: 'bo',
            param: param,
            param2: param2
          }
        }
      } //柜控板


      if (this.cmdForm.type == 0x02) { //充电仓

        this.isDisabled = true
        let param = 0
        let param2 = 0

        switch (val) {
          case 'box_door_open':
            param = 2
            param2 = 1
            break


          case 'box_light_open':
            param = 1
            param2 = 1
            break
          case 'box_light_close':
            param = 1
            param2 = 2
            break

          case 'box_fan_open':
            param = 16
            param2 = 1
            break
          case 'box_fan_close':
            param = 16
            param2 = 2

            break
          default:
        }

        this.cmdForm = {
          req_id: 'test',
          cabinet_id: this.cmdForm.cabinet_id,
          ctrl: val,
          type: 0x02,
          data: {
            id: this.cmdForm.id,
            cmd: 'bo',
            param: param,
            param2: param2
          }
        }
      }

      if (this.cmdForm.type == 0x04) { //充电插座

        this.isDisabled = true
        let param = 0
        let param2 = 0
        switch (val) {
          case 'socket_start_charge':
            param = 2
            param2 = 1
            this.getCurrentLimit(this.current_limit_id)
            //后台获取电流先
            this.cmdForm = {
              req_id: 'test',
              cabinet_id: this.cmdForm.cabinet_id,
              ctrl: 'socket_start_charge',
              type: 0x04,
              data: {
                cmd: 'start_charge',
                id: this.chargeForm.id,
                cn: this.chargeForm.cn,
                max_current: this.chargeForm.max_current,
                float_current: this.chargeForm.float_current,
                float_time: this.chargeForm.float_time,
                fast_time: this.chargeForm.fast_time,
                rise_current: this.chargeForm.rise_current
              }
            }
            break
          case 'socket_stop_charge':
            param = 1
            param2 = 1
            this.cmdForm = {
              req_id: 'test',
              cabinet_id: this.cmdForm.cabinet_id,
              ctrl: 'socket_stop_charge',
              type: 0x04,
              data: {
                cmd: 'stop_charge',
                id: this.chargeForm.id,
                cn: this.chargeForm.cn,
                param: param,
                param2: param2
              }
            }
            break
          case 'pole_start_spray':
            this.cmdForm = {
              req_id: 'test',
              cabinet_id: this.cmdForm.cabinet_id,
              ctrl: 'pole_start_spray',
              type: 0x04,
              data: {
                cmd: 'start_spray',
                id: this.chargeForm.id
              }
            }
            break
          case 'pole_stop_spray':
            this.cmdForm = {
              req_id: 'test',
              cabinet_id: this.cmdForm.cabinet_id,
              ctrl: 'pole_stop_spray',
              type: 0x04,
              data: {
                cmd: 'stop_spray',
                id: this.chargeForm.id
              }
            }
            break

          case 'pole_background_start_spray':
            this.cmdForm = {
              req_id: 'test',
              cabinet_id: this.cmdForm.cabinet_id,
              ctrl: 'pole_background_start_spray',
              type: 0x04,
              data: {
                cmd: 'background_start_spray',
                id: this.chargeForm.id
              }
            }
            break
          case 'pole_background_stop_spray':
            this.cmdForm = {
              req_id: 'test',
              cabinet_id: this.cmdForm.cabinet_id,
              ctrl: 'pole_background_stop_spray',
              type: 0x04,
              data: {
                cmd: 'background_stop_spray',
                id: this.chargeForm.id
              }
            }
            break
          case 'pole_reset':
            this.cmdForm = {
              req_id: 'test',
              cabinet_id: this.cmdForm.cabinet_id,
              ctrl: 'pole_reset',
              type: 0x04,
              data: {
                cmd: 'reset',
                id: this.chargeForm.id
              }
            }
            break
          default:
        }

      }
    }
    ,
    handleCmdCancel() {
      this.cmdVisible = false
      this.cmdForm = {}
      this.$refs['cmdForm'].resetFields()
      this.$refs['cmdForm'].clearValidate()
    }
    ,
    sendCmd() {
      if (this.cmdForm.type == 0x04) {
        var form = {}
        if (this.cmdForm.ctrl == 'socket_start_charge') {
          console.log('-------socket_start_charge--------')
          //后台获取电流先
          form = {
            req_id: 'test',
            cabinet_id: this.cmdForm.cabinet_id,
            ctrl: 'socket_start_charge',
            type: 0x03,
            data: {
              cmd: 'start_charge',
              id: this.chargeForm.id,
              cn: this.chargeForm.cn,
              max_current: this.chargeForm.max_current,
              float_current: this.chargeForm.float_current,
              float_time: this.chargeForm.float_time,
              fast_time: this.chargeForm.fast_time,
              rise_current: this.chargeForm.rise_current
            }
          }
        } else if (this.cmdForm.ctrl == 'socket_stop_charge') {
          form = {
            req_id: 'test',
            cabinet_id: this.cmdForm.cabinet_id,
            ctrl: 'socket_stop_charge',
            type: 0x03,
            data: {
              cmd: 'stop_charge',
              id: this.chargeForm.id,
              cn: this.chargeForm.cn
            }
          }
        } else {
          form = {
            req_id: 'test',
            cabinet_id: this.cmdForm.cabinet_id,
            ctrl: this.cmdForm.ctrl,
            type: 0x03,
            data: {
              cmd: this.cmdForm.data.cmd,
              id: this.chargeForm.id
            }
          }
        }
        this.$refs.cmdForm.validate(valid => {
          if (valid) {
            //柜控板-
            let str = JSON.stringify(form)
            gateway({
              func: 'set_cabinet_ctrl',
              params: str
            }).then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功')
              } else {
                this.$message.error('操作失败：' + res.msg)
              }
            })
          } else {
            return false
          }
        })


      } else {
        this.$refs.cmdForm.validate(valid => {
          if (valid) {
            //柜控板-
            let str = JSON.stringify(this.cmdForm)
            gateway({
              func: 'set_cabinet_ctrl',
              params: str
            }).then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功')
              } else {
                this.$message.error('操作失败：' + res.msg)
              }
            })
          } else {
            return false
          }
        })
      }
    },

    //****************************充电插座
    parsePoleStatus(val) {
      let s = ''
      if ((val & 0x0001) > 0) { //0
        s += ' -运行指示灯亮- '
      }

      if ((val & 0x0002) > 0) {//1
        s += ' -烟雾报警灯- '
      }

      if ((val & 0x0004) > 0) {//2
        s += ' -消防喷淋- '
      }
      return s
    },

    parsePoleError(val) {
      let s = ''

      if ((val & 0x0001) > 0) { //0
        s += ' -烟雾报警- '
      }

      if ((val & 0x0002) > 0) {//1
        s += ' -过流故障- '
      }

      if ((val & 0x0004) > 0) {//2
        s += ' -电压异常- '
      }

      // if ((val & 0x0008) > 0) {//3
      //   s += ' -充电电流异常- '
      // }
      return s
    },

    poleRowClick(row, column, event) {

      this.pole_sockets = []

      if (this.tableData.length > 0 && this.tableData[0].sockets.length > 0) {
        for (let i = 0; i < this.tableData[0].sockets.length; i++) {
          if (this.tableData[0].sockets[i].pole_id == row.pole_id) {
            this.pole_sockets.push(this.tableData[0].sockets[i])
          }
        }
        this.pole_sockets.sort((a, b) => {
          return a.pole_id - b.pole_id
        })

      }
    }
    ,
    parseWaterLevel(val) {
      let s = ''
      if ((val & 0x2000) > 0) {//13   低水位    端子口：10
        s += '-低水位'
      }
      if ((val & 0x4000) > 0) {//14  高水位    端子口：11
        s += '-高水位'
      }
      return s
    },

    parseSocketStatus(val) {

      let s = ''

      if ((val & 0x0001) > 0) { //0
        s += ' 烟雾报警 '
      }

      if ((val & 0x0002) > 0) {//1
        s += ' 声光报警 '
      }

      if ((val & 0x0004) > 0) {//2
        s += ' 充电中 '
      }

      if ((val & 0x0008) > 0) {//3
        s += ' 喷淋启动 '
      }


      return s
    },

    parseSocketError(val) {
      let s = ''

      if ((val & 0x0001) > 0) { //0
        s += ' 负载断开 '
      }

      if ((val & 0x0002) > 0) {//1
        s += ' 过流故障 '
      }

      if ((val & 0x0004) > 0) {//2
        s += ' 电压异常 '
      }

      if ((val & 0x0008) > 0) {//3
        s += ' 充电电流异常 '
      }

      return s
    },


    //****************************充电仓*************


    boxRowClick(row, column, event) {
      this.box_sockets = []
      //console.log(row.box_id)
      this.selected_box_id = row.box_id

      if (this.tableData.length > 0 && this.tableData[0].sockets.length > 0) {
        for (let i = 0; i < this.tableData[0].sockets.length; i++) {
          if (this.tableData[0].sockets[i].box_id == row.box_id) {
            this.box_sockets.push(this.tableData[0].sockets[i])
          }
        }
        this.box_sockets.sort((a, b) => {
          return a.channel - b.channel
        })
      }
    },
    parseBoxStatus(val) {

      let s = ''
      if ((val & 0x0001) > 0) { //0
        s += '直流风机故障-'
      }

      if ((val & 0x0002) > 0) {//1
        // s += '门已关闭-'
      } else {
        s += '门-'
      }

      if ((val & 0x0004) > 0) {//2
        s += '烟感报警-'
      }

      if ((val & 0x0008) > 0) {//3
        s += '电池异常-'
      }

      // if ((val & 0x0010) > 0) {//4
      //
      // }
      //
      // if ((val & 0x0020) > 0) {//5
      //
      // }
      // if ((val & 0x0040) > 0) {//6
      //
      // }
      // if ((val & 0x0080 > 0)) {//7
      //
      // }
      if ((val & 0x0100) > 0) {//8
        s += '照明灯-'
      }
      if ((val & 0x0200) > 0) {//9
        s += '电磁锁-'
      }
      if ((val & 0x0400) > 0) {//10
        s += '加热器-'
      }
      if ((val & 0x0800) > 0) {//11
        s += '交流风机-'
      }
      if ((val & 0x1000) > 0) {//12
        s += '直流风机-'
      }

      if ((val & 0x2000) > 0) {//13
        s += '红灯-'
      }
      if ((val & 0x4000) > 0) {//14
        s += '绿灯-'
      }
      if ((val & 0x8000) > 0) {//15 ledRGB蓝色
        s += '黄灯-'
      }

      if (s.length > 0) {
        s += '  开启'
      }
      return s
    },

    parseBoxError(val) {
      let s = ''
      // if ((val & 0x0001)>0) { //0
      //   s += ' '
      // }
      //
      // if ((val & 0x0002)>0) {//1
      //   s += ' '
      // }
      //
      // if ((val & 0x0004)>0) {//2
      //   s += ' '
      // }
      //
      // if ((val & 0x0008)>0) {//3
      //   s += ' '
      // }
      //
      // if ((val & 0x0010)>0) {//4
      //
      // }
      //
      // if ((val & 0x0020)>0) {//5
      //
      // }
      // if ((val & 0x0040)>0) {//6
      //
      // }
      // if ((val & 0x0080>0)) {//7
      //
      // }
      // if ((val & 0x0100)>0) {//8
      //   s += ' '
      // }
      // if ((val & 0x0200)>0) {//9
      //   s += ' '
      // }
      // if ((val & 0x0400)>0) {//10
      //   s += ' '
      // }
      // if ((val & 0x0800)>0) {//11
      //   s += ' '
      // }
      // if ((val & 0x1000)>0) {//12
      //   s += ' '
      // }
      //
      // if ((val & 0x2000)>0) {//13
      //   s += ' '
      // }
      //
      // if ((val & 0x4000)>0) {//14
      //   s += ' '
      // }
      // if ((val & 0x8000)>0) {//15
      //   s += ' '
      // }
      return s
    },

    //获取时间收费标准
    getCurrentLimit(id) {
      let str = JSON.stringify({
        id: id
      })
      gateway({
        func: 'other_find_current_limit_list',
        params: str
      }).then(res => {
        if (res.code == 0) {


          this.chargeForm.max_current = res.result[0].max_current
          this.chargeForm.float_current = res.result[0].float_current
          this.chargeForm.rise_current = res.result[0].rise_current
          this.chargeForm.float_time = res.result[0].float_time
          this.chargeForm.fast_time = 300
        }
      })
    },

    handleSocketQRCodeClick(row) {
      this.qrcodeVisible = true
      setTimeout(() => {
        this.QRCodeIDs = []
        this.QRCodeIDs.push(this.$global.URL.socket + row.uuid)
        this.createQrCode()
      }, 1000)
    }

  }


}
</script>

<style scoped>

.min {
  width: 100%;
  min-height: 200px;
  overflow: auto;
}

.one {
  width: 100%;
  min-height: 200px;
  float: left;
  overflow: auto;
}

.el-form-item {
  margin-bottom: 15px;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

.blink {
  margin-top: 50 rpx;
  font-size: 36 rpx;
  color: #007AFF;
  animation: blink 1s infinite;
}
</style>

<style lang='scss' scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #C0C4CC;
}


</style>
